export const GET_HRMS_CALENDAR_WORKTIME_TYPWORK = 'GET_HRMS_CALENDAR_WORKTIME_TYPWORK'
export const SET_HRMS_CALENDAR_WORKTIME_TYPWORK = 'SET_HRMS_CALENDAR_WORKTIME_TYPWORK'
export const RECEIVED_HRMS_CALENDAR_WORKTIME_TYPWORK = 'RECEIVED_HRMS_CALENDAR_WORKTIME_TYPWORK'



// WEBPACK FOOTER //
// ./src/store/modules/hrmsCalendarWorkTime/mutation-types.js